export const FacebookIcon = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="36" height="36" rx="18" fill="#487AFA" />
    <path d="M10 16H26L25 21H10V16Z" fill="white" />
    <path
      d="M22 5H26V10H23C21 10 20 11 20 13V36H15V12.5C15 8 18 5 22 5Z"
      fill="white"
    />
  </svg>
);
